<app-navbar title="Terminy płatności"></app-navbar>

<section class="m-3">
	<div class="mb-2">
		<mat-accordion multi>
			<mat-expansion-panel>
				<mat-expansion-panel-header>
					<mat-panel-title
						><i class="fa fa-filter"></i><span class="ms-2 font-wegiht-700">Filtry</span></mat-panel-title
					>
				</mat-expansion-panel-header>
				<app-bag-payment-term-list-filters
					userFilters="paymentTermList"
					[agencies]="parameters().agencies"
					[status]="parameters().status"
					(selected)="filtersSelected($event)"
				></app-bag-payment-term-list-filters>
			</mat-expansion-panel>
		</mat-accordion>
	</div>
	<div class="pb-6">
		<app-bag-payment-term-list-table
			module="paymentTermList"
			[tableColumns]="columns"
			[elements]="data()"
			[agencies]="parameters().agencies"
			[allItemsSize]="allItemsSize()"
			[pageIndex]="page()"
			[pageSize]="pageSize()"
			(page)="pageChanged($event)"
			(sortChanged)="onSortChanged($event)"
			(exportCsv)="exportCsv()"
			(notesChanged)="reloadData()"
		></app-bag-payment-term-list-table>
		<div class="col-sm-3">
			<app-bag-payment-term-list-table-summary
				[totalAmount]="summaryTotalAmount()"
			></app-bag-payment-term-list-table-summary>
		</div>
	</div>
</section>
